// 🔧 pipeline_step.js
// ✅ Purpose: Standard helper for LGV Demo Engine pipeline step results
// ✅ Features:
// - Creates consistent success result objects for pipeline steps
// - Creates consistent failure result objects for pipeline steps
// - Tracks step name, created count, messages, metadata, and elapsed time
// - Keeps Demo Report aggregation clean and predictable
// - Fully block-commented for clarity and future devs

export const createPipelineStepSuccess = ({
  step,
  label,
  created = 0,
  message = "",
  metadata = {},
  startedAt,
} = {}) => {
  const finishedAt = Date.now();

  return {
    step,
    label: label || step,
    success: true,
    created,
    message,
    metadata,
    elapsedMs: startedAt ? finishedAt - startedAt : 0,
  };
};

export const createPipelineStepFailure = ({
  step,
  label,
  error,
  metadata = {},
  startedAt,
} = {}) => {
  const finishedAt = Date.now();

  return {
    step,
    label: label || step,
    success: false,
    created: 0,
    message: error?.message || "Pipeline step failed.",
    metadata,
    elapsedMs: startedAt ? finishedAt - startedAt : 0,
  };
};